import FondationsServiceModel from '@/models/FondationsServiceModel';
import doc                    from '@widesk-core/decorators/doc';

export default class EntityStatusModel extends FondationsServiceModel {
	private declare _tsFilters: {
		'dateEnd[after]': string;
		'dateEnd[before]': string;
		'dateEnd[strictly_after]': string;
		'dateEnd[strictly_before]': string;
		'reference': EntityStatusReferences;
	};
	
	static get path(): string {
		return '/entity_statuses/{?id}';
	}

	@doc.string declare reference: EntityStatusReferences;

	public getLabel(lang: string): string | undefined {
		if (this.reference === 'DISABLED') {
			if (lang === 'en') {
				return 'Disabled';
			}
			if (lang === 'fr') {
				return 'Désactivé';
			}
		}
		if (this.reference === 'ENABLED') {
			if (lang === 'en') {
				return 'Enabled'
			}
			if (lang === 'fr') {
				return 'Activé'
			}
		}
		return undefined;
	}

	public get color(): string | undefined {
		if (this.reference === 'DISABLED') {
			return 'red';
		}
		if (this.reference === 'ENABLED') {
			return 'green';
		}
		return undefined;
	}
}